import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useLocalizationStore } from '../../localization/localizationStore';
import { useEditCanvasStore } from '../../store';
import { useCommandHistory } from '../commands/hooks/useCommandHistory';

export function useUndoRedoShortcuts() {
  const undo = useCommandHistory((state) => state.undo);
  const redo = useCommandHistory((state) => state.redo);
  const readOnly = useEditCanvasStore((state) => state.readOnly);
  // Translate has no undo of its own for a drawn protected area, so Cmd+Z here reaches the canvas
  // history instead and can take the source image out from under the session.
  const localizationActive = useLocalizationStore((state) => state.active);

  const options = useMemo(
    () => ({ enabled: !readOnly && !localizationActive, preventDefault: true }),
    [localizationActive, readOnly],
  );

  useHotkeys('meta+z,ctrl+z', () => undo(), options, [undo, options]);

  useHotkeys('meta+shift+z,ctrl+shift+z', () => redo(), options, [redo, options]);
}
